var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.component,{tag:"component",staticClass:"comment-counter",on:{"click":_vm.onClick}},[_c('i',{staticClass:"af-icons af-icons-comment"}),_vm._v(" "),_c('span',{staticClass:"comment-count"},[_vm._v(_vm._s(_vm.comments.length))])])}
var staticRenderFns = []

export { render, staticRenderFns }